<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="scss">
// @import '@zebra-projects/zebra-ui/src/assets/style/public-class.scss';
@import '@/assets/style/public-class.scss';
</style>
